module.exports = __webpack_public_path__ + "img/Joe_E_Brown_Hall_-_BN-t-24704-055.2824dbdb.jpg";